import { render, staticRenderFns } from "./CstBdAreaModal.vue?vue&type=template&id=53614238&"
import script from "./CstBdAreaModal.vue?vue&type=script&lang=js&"
export * from "./CstBdAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53614238')) {
      api.createRecord('53614238', component.options)
    } else {
      api.reload('53614238', component.options)
    }
    module.hot.accept("./CstBdAreaModal.vue?vue&type=template&id=53614238&", function () {
      api.rerender('53614238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/CstBdAreaModal.vue"
export default component.exports